import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

import './index.css';
import './libs/i18n/i18n.js';
import {BaseURLProvider} from "./context/BaseURLContext";

ReactDOM.createRoot(document.getElementById('root')).render(

    <BrowserRouter>
        <BaseURLProvider>
            <App />
        </BaseURLProvider>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
